import { render, staticRenderFns } from "./PurchaseHint.vue?vue&type=template&id=b91ef950&scoped=true&"
import script from "./PurchaseHint.vue?vue&type=script&lang=js&"
export * from "./PurchaseHint.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseHint.vue?vue&type=style&index=0&id=b91ef950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91ef950",
  null
  
)

export default component.exports